import { endpointTripletex } from './base.config';

export const tripletexRequestLog = {
  getRequestLogCount: `${endpointTripletex}/tripletex/request-logs/count`,
};
